import { PartyInvolved } from "@/src/api/PartiesInvolved";
import { StakeholderRelationship, RELATED_AS_LABELS } from "../../../api/stakeholder_relationships";
import { Stakeholder } from "../../../api/stakeholders";


export function convertStakeholdersToParties(
  stakeholders: Stakeholder[],
  relationships: StakeholderRelationship[],
) {
  const relatedAsLabels = stakeholders.reduce(
    (accumulator, stakeholder) => {
      const uniqueRelatedAs = Array.from(
        new Set(
          relationships
            .filter((r) => r.stakeholder_id === stakeholder.stakeholder_id)
            .map((r) => r.related_as),
        ),
      );
      accumulator[stakeholder.stakeholder_id] = uniqueRelatedAs
        .map((r) => RELATED_AS_LABELS[r])
        .join(", ");
      return accumulator;
    },
    {} as Record<string, string>,
  );

  const result: PartyInvolved[] = stakeholders.map((s) => ({
    party_id: s.stakeholder_id,
    party_type: relatedAsLabels[s.stakeholder_id],
    name: s.name,
    generate_ro: s.is_ro_applicable,
  }));

  return result;
}
